export * from './src/seal-document.component';
export * from './src/seal-document-dialog.service';
